<template>
  <section
    :class="{
      'section-builder-callout': true,
    }"
  >
    <PortableText
      v-if="calloutWithIcon?.heading?.standardPortableText && useInnerBackground"
      :class="{
        'mb-16 mt-50px text-center text-www-color-neutral-medium-dark': true,
      }"
      :portable-data="calloutWithIcon.heading.standardPortableText"
    />
    <GeneralTheme
      :theme="configuration"
      :class="{
        'container border border-www-color-neutral-light': useInnerBackground,
      }"
    >
      <CalloutsWithIcon
        v-if="calloutWithIcon"
        v-bind="calloutWithIcon"
        :use-inner-background="useInnerBackground"
      />
    </GeneralTheme>
  </section>
</template>
<script setup lang="ts">
import PortableText from '~/components/Atoms/PortableText/PortableText.vue';
import GeneralTheme from '~/components/Molecules/Themes/GeneralTheme.vue';
import CalloutsWithIcon from '~/components/Atoms/CalloutsWithIcon/CalloutsWithIcon.vue';
import type { SectionBuilderCalloutWithIcon } from '~/sanity/types';

defineProps<SectionBuilderCalloutWithIcon>();
</script>

<style>
.section-builder-callout h2 {
  font-size: 40px !important;
  font-weight: 800 !important;
}
@media (max-width: 768px) {
  .section-builder-callout h2 {
    font-size: 20px !important;
    line-height: 25px !important;
  }
}
</style>
